import type { Tag } from './types';

/**
 * ブランドカット動画に自動付与されるシステムタグ名。
 * バックエンドの BRAND_CUT_TAG_NAME (backend/routes/async_jobs.py) と一致させること。
 */
export const BRAND_CUT_TAG_NAME = 'ブランドカット';

/** 素材がブランドカット (タイトル/エンドカード用の短尺動画) かどうかをタグで判定する。 */
export function isBrandCutMaterial(material: { tags?: Tag[] | null }): boolean {
  return material.tags?.some((tag) => tag.name === BRAND_CUT_TAG_NAME) ?? false;
}

/**
 * サウンドロゴ音声に自動付与されるシステムタグ名。
 * バックエンドの ensure_tag(org, 'サウンドロゴ') (backend/routes/brands.py) と一致させること。
 */
export const SOUND_LOGO_TAG_NAME = 'サウンドロゴ';

/** 素材がサウンドロゴ (ブランドの音響識別子となる音声) かどうかをタグで判定する。 */
export function isSoundLogoMaterial(material: { tags?: Tag[] | null }): boolean {
  return material.tags?.some((tag) => tag.name === SOUND_LOGO_TAG_NAME) ?? false;
}
